import React, { useState } from 'react';
import { Box, ButtonBase, Menu, MenuItem, Typography } from '@mui/material';
import { RiArrowDownSFill } from 'react-icons/ri';

interface SearchBarMenuOption {
	key: string;
	label: string;
}

interface SearchBarMenuProps {
	value: string;
	onChange?: (value: string) => void;
	options: SearchBarMenuOption[];
}

const SearchBarMenu = (props: SearchBarMenuProps) => {
	const { options, value, onChange } = props;
	const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null);
	const selectedOption = options.find((o) => o.key === value);

	return (
		<>
			<ButtonBase
				focusRipple
				sx={{
					alignSelf: 'stretch',
					height: '100%',
				}}
				onClick={(e) => setMenuAnchorEl(e.currentTarget)}
			>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
						paddingRight: (theme) => theme.spacing(2),
						height: '100%',
						pl: 2,
					}}
				>
					<Typography variant="body2">{selectedOption?.label}</Typography>
					<RiArrowDownSFill />
				</Box>
			</ButtonBase>
			<Menu
				open={Boolean(menuAnchorEl)}
				onClose={() => setMenuAnchorEl(null)}
				anchorEl={menuAnchorEl}
				onClick={() => setMenuAnchorEl(null)}
				PaperProps={{
					sx: {
						minWidth: 200,
					},
				}}
			>
				{options.map((o) => (
					<MenuItem key={o.key} selected={value === o.key} onClick={() => onChange?.(o.key)}>
						{o.label}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default SearchBarMenu;
